// @flow

import styled, { css } from 'styled-components';
import {theme} from '@tectonics/look-and-feel/uber-v2/theme';
export const SidePanel = styled.div`
  background: white;
  position: fixed;
  width: 282px;
  top: 96px;
  border-top-right-radius: ${theme.radius};
  border-bottom-right-radius: ${theme.radius};
  ${theme.layout.raised && css`
    box-shadow: 0 1px 13px 0 rgba(76,76,76,0.15);
  `}
  ${theme.layout.bordered && css`
    border-width: 1px 1px 1px 0;
    border-style: solid;
    border-color: ${theme.colors.primary(67)};
  `}
`;
